import React, { useEffect, useState } from 'react'
import { Autocomplete, createFilterOptions, TextField } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import { useTranslation } from 'react-i18next'
import { LabelProps } from './Label'
import api from '../services/api'
import { LabelType } from '../domain/enum/LabelType'

type Props = {
  errorMessage?: string | null
  label?: string
  onChange: any
  value: any
}

export function InputTags ({ errorMessage = null, label, onChange, value, ...rest }: Props) {
  const { t } = useTranslation()
  const filter = createFilterOptions()
  const [labels, setLabels] = useState<LabelProps[]>([])
  const [selectLabels, setSelectLabels] = useState(value)
  const dataFetch = async () => {
    const labelsResult = await api.get('labels')
    if (labelsResult.data) {
      const labelsFiltered = labelsResult.data.filter((item: any) => item.type === 'ROUTINE')
      setLabels(labelsFiltered)
    }
  }

  const saveLabel = async (value: any) => {
    if (!labels.map(item => item.name).includes(value)) {
      const result = await api.post('labels', { name: value, type: LabelType.ROUTINE })
      if (result.data) {
        const label = {
          id: result.data.id,
          name: result.data.name
        }
        setLabels(oldArray => [...oldArray, result.data])
        return label
      }
      return null
    }
  }

  useEffect(() => {
    dataFetch().then(() => setSelectLabels(value)).catch(console.error)
  }, [value])

  return (
    <FormControl>
      <Autocomplete
        {...rest}
        value={selectLabels !== undefined ? selectLabels : []}
        multiple
        options={labels}
        handleHomeEndKeys
        onChange={async (event: any, selectValues: any) => {
          const newSelectLabels = []
          for (const selectValue of selectValues) {
            if (selectValue?.id !== undefined) {
              newSelectLabels.push(selectValue)
              continue
            }
            newSelectLabels.push(await saveLabel(selectValue.inputValue))
          }
          setSelectLabels(newSelectLabels)
          onChange(newSelectLabels)
        }}
        renderOption={(props, option: any) =>
          <li {...props} key={(option?.id !== undefined) ? option.id : Math.random().toString()}>{option.name}</li>}
        getOptionLabel={(option: any) => {
          if (typeof option === 'string') {
            return option
          }
          if (option.inputValue) {
            return option.inputValue
          }
          return option.name
        }}
        filterOptions={(options: any, params: any) => {
          const filtered = filter(options, params)
          if (params.inputValue !== '') {
            filtered.push({
              inputValue: params.inputValue,
              name: `${t('add')} "${params.inputValue}"`
            })
          }
          return filtered
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            placeholder={label}
            autoComplete="off"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {/*{loadingIncomeAut ? <CircularProgress color="inherit" size={20}/> : null}*/}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        )}
      />
    </FormControl>
  )
}
